import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import LoginLayout from "../layouts/LoginLayout";
import SignUp from "../pages/auth/SignUp";
import Login from "../pages/auth/Login";
import Dashboard from "../pages/dashboard/Dashboard";
import SidebarLayout from "../layouts/SidebarLayout";
import PrivateRoute from "./PrivateRoute";
import Project from "../pages/dashboard/project/Project";
import Role from "../pages/role/Role";
import Integration from "../pages/integration/Integration";
import Configurator from "../pages/configurator/Configurator";
import { useEffect, useState } from "react";
import ConfiguratorProject from "../pages/configurator/forms/ConfiguratorProject";
import { useAuth } from '../hooks/AuthContext';
import {checkRoleUpdation,updateRoleUpdation} from "../services/apiService";
import Repo from '../pages/repo/Repo'
import TextEnhancer from "../pages/TextEnhancer/TextEnhancer";
import KpiDashboard from "../pages/kpiDashboard/KpiDashboard";
import Clinics from "../pages/clinics/Clinics";
import { canViewKpiPages, isKpiOnlyAccount } from "../utils/access";
import Se_project_creation from "../pages/se_project_creation/se_project_creation";
// import DynamicQr from "./DynamicQr";


function MainContent() {
    const [error, setError] = useState<string | null>(null);
    const [isError, setIsError] = useState<boolean>(false);
    const location = useLocation();
    const hideSidebarRoutes = ['/login', '/signup', '/logout'];
    const [isAuthenticated, setIsAuthenticated] = useState(false);
  
    const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname);
    const { logout } = useAuth();
    async function checkRoleUpdationfun() { 
      return await checkRoleUpdation(localStorage.getItem('id')); 
    }
    useEffect(() => { 
      const checkRole = async () => { 
        const result = await checkRoleUpdationfun(); 
        if(result.role_update == 'true'){
            setIsAuthenticated(false);
            logout()
        }
      }; 
      const intervalId = setInterval(checkRole, 600000); 
      return () => clearInterval(intervalId); 
    }, []);

    useEffect(() => {
      if (localStorage.getItem('isLoggedIn') === 'true') {
        setIsAuthenticated(true);
      }
    }, []);
  
    return (
      shouldHideSidebar ? (
        <LoginLayout isError={isError} error={error} setIsError={setIsError}>
          <Routes>
            <Route path="/login" element={<Login setError ={setError} setIsError={setIsError}/>} />
            <Route path="/signup" element={<SignUp  setError ={setError} setIsError={setIsError}/>} />
          </Routes>
        </LoginLayout>) : (
        <SidebarLayout isError={isError} error={error} setIsError={setIsError}>
          {isKpiOnlyAccount() ? (
            <Routes>
              <Route path="/kpi-dashboard" element={<PrivateRoute element={<KpiDashboard setError ={setError} setIsError={setIsError}/>} />} />
              <Route path="/clinics" element={<PrivateRoute element={<Clinics setError ={setError} setIsError={setIsError}/>} />} />
              {/* This account has no access to the other screens - send everything else to the KPI dashboard. */}
              <Route path="*" element={<Navigate to={isAuthenticated ? "/kpi-dashboard" : "/login"} />} />
            </Routes>
          ) : (
            <Routes>
              <Route path="/dashboard" element={<PrivateRoute element={<Dashboard setError ={setError} setIsError={setIsError}/>} />} />
              <Route path="/dashboard/projects" element={<PrivateRoute element={<Project setError ={setError} setIsError={setIsError}/>} />} />
              <Route path="/configurator" element={<PrivateRoute element={<Configurator setError ={setError} setIsError={setIsError}/>} />} />
              <Route path="/3drepo" element={<PrivateRoute element={<Repo setError ={setError} setIsError={setIsError}/>} />} />
              <Route path="/configurator/form" element={<PrivateRoute element={<ConfiguratorProject setError ={setError} setIsError={setIsError}/>} />} />
              <Route path="/integration" element={<PrivateRoute element={<Integration />} />} />
              <Route path="/roles" element={<PrivateRoute element={<Role setError ={setError} setIsError={setIsError}/>} />} />
              {/* <Route path="/dynamicqr" element={<DynamicQr/>}/> */}
              <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard?page=1" : "/login"} />} />
              <Route path="/TextEnhancer" element={<PrivateRoute element={<TextEnhancer setError ={setError} setIsError={setIsError}/>} />} />
              {/* Super admins get the KPI screens on top of everything above. */}
              {canViewKpiPages() && <Route path="/kpi-dashboard" element={<PrivateRoute element={<KpiDashboard setError ={setError} setIsError={setIsError}/>} />} />}
              {canViewKpiPages() && <Route path="/clinics" element={<PrivateRoute element={<Clinics setError ={setError} setIsError={setIsError}/>} />} />}
              {canViewKpiPages() && <Route path="/se_project_creation" element={<PrivateRoute element={<Se_project_creation/>} />} />}
            </Routes>
          )}
        </SidebarLayout>)
    );
  }

  export default MainContent;